__turbopack_context__.v({
  "booknow": "navbar-module-scss-module__-YerNa__booknow",
  "burger": "navbar-module-scss-module__-YerNa__burger",
  "burgerAlign": "navbar-module-scss-module__-YerNa__burgerAlign",
  "contactcontainer": "navbar-module-scss-module__-YerNa__contactcontainer",
  "contactcontainerhide": "navbar-module-scss-module__-YerNa__contactcontainerhide",
  "contactcontainershow": "navbar-module-scss-module__-YerNa__contactcontainershow",
  "icon-btn": "navbar-module-scss-module__-YerNa__icon-btn",
  "logo": "navbar-module-scss-module__-YerNa__logo",
  "navbar": "navbar-module-scss-module__-YerNa__navbar",
  "phone": "navbar-module-scss-module__-YerNa__phone",
  "spanLine": "navbar-module-scss-module__-YerNa__spanLine",
});
